import { useGetClientOne } from "../../../fnx/client/getClientOne";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { clientOneClearData } from "../../../store/client/actions";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
export var useClientData = function () {
    var dispatch = useDispatch();
    var _a = React.useState([]), companyList = _a[0], setCompanyList = _a[1];
    var clientId = useState(findParamInLocalStorage("clientId"))[0];
    var _b = useGetClientOne(true, clientId !== null && clientId !== void 0 ? clientId : ""), responseOneClient = _b.responseOneClient, loadingOneClient = _b.loadingOneClient, errorOneClient = _b.errorOneClient;
    useEffect(function () {
        if (responseOneClient) {
            var newList = [
                {
                    id: responseOneClient.id,
                    name: responseOneClient.description,
                    value: responseOneClient.id,
                },
            ];
            setCompanyList(newList);
            dispatch(clientOneClearData());
        }
    }, [responseOneClient]);
    return { companyList: companyList, loadingOneClient: loadingOneClient, errorOneClient: errorOneClient };
};
